module.exports = __webpack_public_path__ + "static/media/YL_atyourservice_Desktop-1.cc716e4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_atyourservice_Desktop-1.png
// module id = 1270
// module chunks = 0